// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class IframeModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public onLoad(iframe) {
    let iframeUrl = document.createElement("a");
    iframeUrl.setAttribute("href", iframe.src);
    let iframeHost = iframeUrl.hostname;

    if (iframeHost != window.location.hostname) {
      /** @ts-ignore */
      var eventMethod = window.addEventListener
        ? "addEventListener"
        : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
      eventer(
        messageEvent,
        function (e) {
          if (isNaN(e.data)) return;
          var height = parseInt(e.data);
          if (height < 10) {
            height = 200;
          }

          iframe.style.height = height + "px";
        },
        false
      );
    } else {
      var html = iframe.contentWindow.document.documentElement;
      var body = iframe.contentWindow.document.body;
      var height =
        Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        ) + 4;
      iframe.style.height = height + "px";
    }
  }
}
